<div class="status-rejected form-container">
  <img src="assets/icons/error-warning.svg" alt="Icono Rechazado" />
  <h4>Lo sentimos</h4>
  <p>Encontramos un error en el proceso que nos impide seguir. Por favor, inténtalo nuevamente.</p>
  <div>
    <button class="btn-primary-bg" (click)="onKillPurchase()">Volver al comercio</button>
  </div>
</div>
